/* eslint-disable */
// @ts-nocheck

import React from "react";
import Form from "../../ui/Form/Form";
import Button, { Icons } from "../buttons/Button";
import DragndropContainer from "../fileUpload/DragNdropContainer";
import FileUploaderItem from "../fileUpload/FileUploaderItem";
import { ReactComponent as CSV } from "../../assets/icons/csvIcon.svg";
import { BULK_UPLOAD_GENERAL_TRANSLATIONS } from "../../translations/util";

interface IProps {
  labelText: string;
  multiple?: boolean;
  filenameStatus?: string;
  onAddFiles: (data: any) => void;
  handleDownloadTemplate: () => void;
  handleFileDelete?: () => void;
  handleFileSubmit?: () => void;
  filename?: string;
  dataLoading?: boolean;
  showReport?: boolean;
  fileType?: string;
  isColumnMistached?: boolean;
  isBulkLimitReached?: boolean;
  notes?: string[];
}
const ImportFile = ({
  labelText,
  multiple = false,
  filenameStatus = "edit",
  onAddFiles,
  handleDownloadTemplate,
  handleFileDelete,
  handleFileSubmit,
  notes = [
    BULK_UPLOAD_GENERAL_TRANSLATIONS.Notes.point1,
    BULK_UPLOAD_GENERAL_TRANSLATIONS.Notes.point2,
  ],
  filename = undefined,
  dataLoading,
  showReport,
  fileType,
  isColumnMistached,
  isBulkLimitReached,
}: IProps) => {
  // This function returns error subject based on conditions
  const handleErrorSubject = () => {
    let errorSubject = "";
    if (isColumnMistached) {
      errorSubject = BULK_UPLOAD_GENERAL_TRANSLATIONS.ColumnMismatchText;
    }
    if (isBulkLimitReached) {
      errorSubject = BULK_UPLOAD_GENERAL_TRANSLATIONS.MaxRowLimitText;
    }
    if (fileType !== "text/csv") {
      errorSubject = BULK_UPLOAD_GENERAL_TRANSLATIONS.InvalidFileTypeText;
    }

    return errorSubject;
  };

  return (
    <div className="data-form">
      {}
      <Form>
        <div className="data-tabcontent data-card bulk-upload-card">
          <h4 className="import-tab-title" data-cy="tab-title">
            {BULK_UPLOAD_GENERAL_TRANSLATIONS.ImportTab.title}
          </h4>
          <h5 className="instruction-text" data-cy="tab-subtitle">
            {" "}
            {
              BULK_UPLOAD_GENERAL_TRANSLATIONS.ImportTab
                .downloadTemplateInstructionText
            }{" "}
            <a
              onClick={() => handleDownloadTemplate()}
              data-cy="download-templateCSV-button"
            >
              {" "}
              {
                BULK_UPLOAD_GENERAL_TRANSLATIONS.ImportTab
                  .downloadTemplateLinkText
              }{" "}
            </a>{" "}
          </h5>
          <div className="dragndrop-container" data-cy="dragndrop-container">
            <DragndropContainer
              labelText={labelText}
              multiple={multiple}
              filenameStatus={dataLoading ? "uploading" : filenameStatus}
              onAddFiles={onAddFiles}
              disabled={!!filename}
            />
          </div>
          {filename ? (
            <div className="file-block flex items-center justify-between">
              <div className="flex items-center">
                <CSV />
                <FileUploaderItem
                  name={BULK_UPLOAD_GENERAL_TRANSLATIONS.ImportTab.handleFileUpoadtext(
                    filename
                  )}
                  data-cy="file-uploader-item"
                  status={dataLoading ? "uploading" : filenameStatus}
                  onDelete={handleFileDelete}
                  invalid={
                    fileType !== "text/csv" ||
                    isColumnMistached ||
                    isBulkLimitReached
                  }
                  errorSubject={handleErrorSubject()}
                />
              </div>

              <Button
                kind="primary"
                className="border-none no-outline w-0 mr-3 file-upload-button"
                type="button"
                icon={Icons.Upload}
                label={
                  BULK_UPLOAD_GENERAL_TRANSLATIONS.ImportTab.uploadButtonLabel
                }
                onClick={handleFileSubmit}
                disabled={
                  showReport ||
                  dataLoading ||
                  fileType !== "text/csv" ||
                  isColumnMistached ||
                  isBulkLimitReached
                }
                dataCy="fileUpload-"
              />
            </div>
          ) : null}
          <div className="instruction-list" data-cy="instructions">
            <h4> {BULK_UPLOAD_GENERAL_TRANSLATIONS.Notes.title} </h4>
            <ul>
              {notes?.map((point: string, index: number) => {
                return <li data-cy={`note-${index}`}>{point}</li>;
              })}
            </ul>
          </div>
        </div>
      </Form>
    </div>
  );
};

export default ImportFile;
